<template>
	<dms-wrapper :show-label="false" v-bind="{wrapp, span, validationRules, noLabelAlign}" :validation-property="validationPropertyCmp" :disabled="isDisabled">
		<el-radio-group v-model="valueCmp">
			<el-radio-button v-for="(radioLabel) in radioLabels" :key="radioLabel.value" :label="radioLabel.value" :disabled="isDisabled">
				{{ radioLabel.text }}
			</el-radio-button>
			<el-radio-group v-model="value" />
		</el-radio-group>
	</dms-wrapper>
</template>

<script>
import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default BaseInput.extend({
	name: 'DmsRadioButton',
	components: { DmsWrapper },
	props: {
		radioLabels: { type: Array, default: () => [] },
		value: { type: [String, Number] },
		oneLine: { type: Boolean, default: false },
		noLabelAlign: { type: Boolean, default: false },
		asButton: Boolean,
	},
	computed: {
		radioLabelCmp() {
			return this.radioLabel === null ? this.labelKey || 0 : this.radioLabel;
		},
		componentName() {
			return this.asButton ? 'el-radio-button' : 'el-radio';
		},
	},
});
</script>
